export class TablePagination {
  first: number = 0;
  page: number = 0;
  rows: number = 10;
  totalItems: number = 0;
  last: number = 0;
  sortBy?: any;
  sortDirection?: any;

  constructor(init?: Partial<TablePagination>) {
    Object.assign(this, init);
  }
}
